import { useLocation, useNavigate } from 'react-router';

/**
 * Realiza a navegação para a tela anterior.
 * Caso seja a primeira tela sendo acessada, redireciona para a tela inicial ou para tela de listagem.
 */
export default function useNavigateBack() {
    const navigate = useNavigate();
    const location = useLocation();

    const goBack = (defaultFallback = '/') => {
        const hasInternalHistory = window.history.state && window.history.state.idx > 0;

        // há navegação interna no sistema
        if (hasInternalHistory) {
            navigate(-1);
        }
        // primeira rota do sistema, não navegou de tela
        else {
            // caso esteja numa rota de form, volta pra listagem
            if (location.pathname.includes('/form')) {
                const basePath = location.pathname.split('/form')[0];

                navigate(basePath, { replace: true });
            }
            // senão, volta à tela inicial
            else {
                navigate(defaultFallback, { replace: true });
            }
        }
    };

    return goBack;
}
